<app-navbar></app-navbar>
<div id="content">
  <router-outlet></router-outlet>
</div>

@if (showStartupPopup) {
<div class="startup-popup-backdrop" [class.is-closing]="isStartupPopupClosing" (click)="closeStartupPopup()">
  <div class="startup-popup-card" (click)="$event.stopPropagation()">
    <button class="startup-popup-close" type="button" aria-label="Cerrar" (click)="closeStartupPopup()">×</button>
    <div class="startup-popup-noise" aria-hidden="true"></div>
    <div class="startup-popup-orb"></div>

    <div class="startup-popup-content">
      <div class="startup-popup-copy-col">
        <p class="startup-popup-badge">Diagnóstico sin costo</p>
        <h2>
          <span>Descubre cómo generar más clientes</span>
          <span class="startup-popup-title-outline">en 15 minutos</span>
        </h2>
        <p class="startup-popup-copy">
          Analizamos tu negocio, detectamos oportunidades de crecimiento y te mostramos cómo escalar con marketing,
          tecnología y automatización.
        </p>

        <div class="startup-popup-points">
          <span>Growth</span>
          <span>Performance</span>
          <span>Automatización</span>
        </div>

        <div class="startup-popup-actions">
          <button
            type="button"
            class="startup-popup-cta startup-popup-cta--loud"
            [disabled]="!hasCalendlyUrl"
            (click)="openCalendly()"
          >
            Agenda tu diagnóstico
            <i class="bi bi-arrow-up-right"></i>
          </button>
          <button class="startup-popup-secondary" type="button" (click)="closeStartupPopup()">
            Seguir explorando
          </button>
        </div>
      </div>

      <aside class="startup-popup-visual" aria-hidden="true">
        <div class="startup-popup-image-frame">
          <img class="img-fluid" [src]="startupPopupImageUrl" alt="" loading="lazy" />
        </div>
      </aside>
    </div>
  </div>
</div>
}

<app-footer></app-footer>
<app-dingo-ai-widget></app-dingo-ai-widget>
